var Swiper = require('swiper/js/swiper.js');

import jquery from 'jquery';
global.jQuery = jquery;
global.$ = jquery;
global.jquery = jquery;

// ******  Home Page - Main Slider ****** //
export var introSwiper = new Swiper('.intro .swiper-container', {
    loop: true,
    autoplay: {
        delay: 5000
    },
    speed: 900,
    parallax: true,
    grabCursor : true,
    autoplayDisableOnInteraction: false,
    clickable: true,
    navigation: {
        nextEl: '.intro .swiper-img-next',
        prevEl: '.intro .swiper-img-prev',
    },
    pagination: {
        el: '.intro .swiper-pagination'
    },
});

/*** Slide Counter Method - Main Slider ***/
const slideCounter = function () {
    const mainSliderActive = $(".intro-slider .swiper-wrapper .swiper-slide-active");
    const getSlideNumberFirst = mainSliderActive.data("slide-first");
    const getSlideNumberTotal = mainSliderActive.data("slide-total");

    const setSlideNumberFirst = $(".slide-number-index");
    const setSlideNumberTotal = $(".slide-number-total");
    (getSlideNumberFirst < 10 ? setSlideNumberFirst.text('0' + getSlideNumberFirst) :  setSlideNumberFirst.text(getSlideNumberFirst));
    (getSlideNumberTotal < 10 ? setSlideNumberTotal.text('0' + getSlideNumberTotal) :  setSlideNumberTotal.text(getSlideNumberTotal));
};
slideCounter();

introSwiper.on('slideChange', function() {
    slideCounter();
});

$(".intro-slider .swiper-btn-next, .intro-slider .swiper-btn-prev").click(function() {
    slideCounter();
});





// ******  Home Page - Services Slider ****** //
export var servicesSwiper = new Swiper('.services .swiper-container', {
    loop: true,
    autoplay: {
        delay: 5000
    },
    effect: 'fade',
    speed: 900,
    autoplayDisableOnInteraction: false,
    grabCursor : true,
    clickable: true,
    navigation: {
        nextEl: '.services .swiper-btn-next',
        prevEl: '.services .swiper-btn-prev',
    },
    pagination: {
        el: '.services .swiper-pagination'
    },
    fadeEffect: {
        crossFade: true
    },
});

if ($(window).width() < 768) {
   if ($('body').hasClass('body-index'))  {
       introSwiper.autoplay.stop();
   }
}

let servicesSwiperButtons = $('.services-slider .swiper-btn');
servicesSwiperButtons.on('click', function () {
    servicesSwiperButtons.removeClass('active');
    $(this).addClass('active');
});


// Offer view slider
const galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
        475: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 5,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
const galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    clickable: true,
    thumbs: {
        swiper: galleryThumbs
    }
});



